/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SortType = {
    ProjectTitle: 'PROJECT_TITLE',
    Status: 'STATUS',
    StartDate: 'START_DATE',
    EndDate: 'END_DATE',
    SortDateForClient: 'SORT_DATE_FOR_CLIENT',
    ProjectOwner: 'PROJECT_OWNER',
    Company: 'COMPANY',
    Organization: 'ORGANIZATION',
    PurchaseOrder: 'PURCHASE_ORDER',
    Freelancer: 'FREELANCER',
    FreelancerPrice: 'FREELANCER_PRICE',
    Total: 'TOTAL',
    Action: 'ACTION',
    VerticalType: 'VERTICAL_TYPE',
    OpportunityType: 'OPPORTUNITY_TYPE',
    RenewalStatus: 'RENEWAL_STATUS'
} as const;
export type SortType = typeof SortType[keyof typeof SortType];


export function instanceOfSortType(value: any): boolean {
    for (const key in SortType) {
        if (Object.prototype.hasOwnProperty.call(SortType, key)) {
            // @ts-ignore
            if (SortType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SortTypeFromJSON(json: any): SortType {
    return SortTypeFromJSONTyped(json, false);
}

export function SortTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SortType {
    return json as SortType;
}

export function SortTypeToJSON(value?: SortType | null): any {
    return value as any;
}

